<template>
  <div>
    <loading-spinner v-if="!distributor" />
    <app-header v-if="distributor" :title="originalName ? editTitle : newTitle">
      <template #col-right>
        <b-button variant="primary" class="mr-2" @click="save">
          <span v-label-key="'SAVE_CHANGES'">Save Changes</span>
        </b-button>
        <cancel-button />
      </template>
    </app-header>

    <div v-if="distributor" class="container">
      <b-row>
        <b-col md="6">
          <errors v-if="errors.length" :errors="errors" />
          <b-form ref="editorForm">
            <b-form-group
              :label="`${getLabel('NAME')} *`"
              :description="getLabel('EDIT_DISTRIBUTOR_NAME_DESCRIPTION')"
            >
              <b-form-input v-model="distributor.name" type="text" required />
            </b-form-group>
            <b-form-group
              :label="getLabel('DASHBOARD_CONTACT_EMAIL')"
              :description="getLabel('DASHBOARD_CONTACT_EMAIL_DESCRIPTION')"
            >
              <b-form-input
                v-model="distributor.dashboard_contact_email"
                type="text"
              />
            </b-form-group>
            <b-form-group
              :label="getLabel('EDIT_DISTRIBUTOR_CONTACT_EMAIL')"
              :description="
                getLabel('EDIT_DISTRIBUTOR_CONTACT_EMAIL_DESCRIPTION')
              "
            >
              <b-form-input
                v-model="distributor.warranty_contact_email"
                type="text"
              />
            </b-form-group>
            <b-form-group
              :label="getLabel('EDIT_DISTRIBUTOR_TUTORIAL_LINK')"
              :description="
                getLabel('EDIT_DISTRIBUTOR_TUTORIAL_LINK_DESCRIPTION')
              "
            >
              <b-form-input v-model="distributor.tutorial_link" type="text" />
            </b-form-group>
            <b-form-group
              :label="getLabel('EDIT_DISTRIBUTOR_REWARD_LINK')"
              :description="
                getLabel('EDIT_DISTRIBUTOR_REWARD_LINK_DESCRIPTION')
              "
            >
              <b-form-input v-model="distributor.reward_program_link" type="url" />
            </b-form-group>
            <template
              v-if="
                auth.user.selectedAccess.roleLevel > 3 ||
                  (auth.user.selectedAccess.roleLevel > 2 &&
                    distributor &&
                    distributor.id === 40)
              "
            >
              <b-form-group
                :label="getLabel('LOGO')"
                :description="getLabel('EDIT_DISTRIBUTOR_LOGO_DESCRIPTION')"
              >
                <!-- <input type="text" class="form-control" v-model="distributor.logo"> -->
                <file-input
                  accept="image/*"
                  v-model="distributor.logo"
                  folder="distributorlogos"
                />
              </b-form-group>
            </template>

            <template v-if="auth.user.selectedAccess.roleLevel > 3">
              <br />
              <h3 v-label-key="'EDIT_DISTRIBUTOR_SUPERADMIN_HEADER'">
                Superadmin only
              </h3>
              <!-- <b-form-group
                label="Sender Email"
                description='This sets the email address that emails like "Reset Password" will be sent from.  IMPORTANT: this email address must be separately verified or emails will fail to send.'
              >
                <b-form-input v-model="distributor.sender_email" type="email" />
              </b-form-group> -->
              <!-- <b-form-group
                :label="getLabel('APP_ANDROID_ID')"
                :description="
                  getLabel('EDIT_DISTRIBUTOR_ANDROID_APP_ID_DESCRIPTION')
                "
              >
                <b-form-input
                  v-model="distributor.android_app_id"
                  type="text"
                />
              </b-form-group> -->
              <b-form-group>
                <label class="form-check">
                  <input
                    v-model="distributor.enable_brand_image"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <span
                    class="form-check-label"
                    v-label-key="'DISTRIBUTOR_SETTING_ENABLE_BRAND_IMAGE'"
                  ></span>
                  <small
                    class="form-text text-muted"
                    v-label-key="
                      'DISTRIBUTOR_SETTING_ENABLE_BRAND_IMAGE_DESCRIPTION'
                    "
                  ></small>
                </label>
              </b-form-group>
              <b-form-group
                :label="getLabel('EDIT_DISTRIBUTOR_DOMAIN_NAME')"
                :description="
                  getLabel('EDIT_DISTRIBUTOR_DOMAIN_NAME_DESCRIPTION')
                "
              >
                <b-form-input v-model="distributor.domain_name" type="text" />
              </b-form-group>
              <b-form-group
                :label="getLabel('EDIT_DISTRIBUTOR_FILM_TYPE_CATEGORY')"
                :description="
                  getLabel('EDIT_DISTRIBUTOR_FILM_TYPE_CATEGORY_DESC')
                "
              >
                <b-form-select
                  v-if="filmtypecategories"
                  v-model="distributor.filmtypecategory_id"
                  required
                  :options="filmtypecategories"
                  text-field="name"
                  value-field="id"
                />
              </b-form-group>
              <b-form-group
                :label="getLabel('EDIT_DISTRIBUTOR_CUSTOM_CSS')"
                :description="getLabel('EDIT_DISTRIBUTOR_CUSTOM_CSS_DESC')"
              >
                <file-input
                  v-model="distributor.custom_css"
                  folder="distributor/customcss"
                />
              </b-form-group>
            </template>
          </b-form>
        </b-col>
        <b-col md="8" />
      </b-row>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import $auth from '@/services/auth';
import CancelButton from '@/components/CancelButton';
import LoadingSpinner from '@/components/LoadingSpinner';
import Errors from '@/components/Errors';
import AppHeader from '@/components/AppHeader';
import FileInput from '@/components/FileInput';
import { mapGetters } from 'vuex';

// https://cdn.gokaizen.com/distributor/customcss/fc6123ad-2e3a-4b3e-8036-446329fc48f3
export default {
  components: {
    CancelButton,
    LoadingSpinner,
    Errors,
    AppHeader,
    FileInput,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
      getReplaceLabel: 'getReplaceLabel',
    }),
    editTitle() {
      return this.getReplaceLabel('EDIT_ITEM_NAME', {
        '{NAME}': this.originalName,
      });
    },
    newTitle() {
      return this.getReplaceLabel('NEW_ITEM_NAME', {
        '{NAME}': this.getLabel('DISTRIBUTOR'),
      });
    },
  },
  data() {
    return {
      auth: $auth,
      originalName: null,
      distributor: null,
      filmtypecategories: null,
      errors: [],
    };
  },
  created() {
    this.refreshData();
  },
  methods: {
    async refreshData() {
      if (this.$route.query.id) {
        $api
          .get(`/v1/dashboard/distributors/${this.$route.query.id}`)
          .then((distributor) => {
            this.originalName = distributor.name;
            this.distributor = distributor;
          });
      } else {
        this.distributor = {
          enable_brand_image: 1,
        };
      }
      this.filmtypecategories = await $api.get('/v1/common/filmtypecategories');
    },
    validateForm() {
      this.errors = [];

      if (!this.distributor.name) {
        this.errors.push(
          this.getLabel('FORM_ERROR_NAME_REQUIRED') ||
            'The name field is required.',
        );
      }
    },
    save() {
      if (!this.$refs.editorForm.checkValidity()) {
        this.validateForm();
        this.$refs.editorForm.reportValidity();
        return;
      }
      this.errors = [];
      if (this.distributor.id) {
        $api
          .put(
            `/v1/dashboard/distributors/${this.distributor.id}`,
            this.distributor,
          )
          .then((distributor) => {
            this.$router.push({
              name: 'distributor-detail',
              params: distributor,
            });
          });
      } else {
        $api
          .post('/v1/dashboard/distributors', this.distributor)
          .then((distributor) => {
            this.$router.push({
              name: 'distributor-detail',
              params: distributor,
            });
          });
      }
    },
  },
};
</script>
